import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash';
import NavLink from 'components/nav/shared/NavLink';
import LanguagePicker from 'components/nav/shared/LanguagePickerContainer';

import AccountStore from 'stores/AccountStore';
import IdentityStore from 'stores/IdentityStore';
import I18nStore from 'stores/I18nStore';

const UnauthenticatedItems = ({ hideJoinLink }) => {
  const { account } = AccountStore.getState();
  const identity = IdentityStore.getState().currentIdentity;
  const isLoggedIn = !account;
  const localeQueryString = I18nStore.getState().currentLocale
    ? (`?locale=${I18nStore.getState().currentLocale}`) : '';
  const signInPath = `/home${localeQueryString}`;
  const signOutPath = `/signout${localeQueryString}`;
  const joinPath = `/claim${localeQueryString}`;
  const showJoinLink = (isNil(identity) && !hideJoinLink);

  return (
    <ul className="nav navbar-nav">
      {showJoinLink && <li><NavLink to={joinPath} shouldRefresh={isLoggedIn} stringID="AA_Join" /></li>}
      { account
        ? <li><NavLink to={signOutPath} shouldRefresh stringID="AA_SignOut" /></li>
        : <li><NavLink to={signInPath} shouldRefresh stringID="AA_Login" /></li>
      }
      <li><LanguagePicker className="hidden-xs" /></li>
      <li><NavLink to="/help" stringID="AA_Help" /></li>
    </ul>
  );
};

UnauthenticatedItems.contextTypes = {
  getString: PropTypes.func.isRequired,
};
UnauthenticatedItems.propTypes = {
  hideJoinLink: PropTypes.bool,
};

export default UnauthenticatedItems;
